<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "app"
};
</script>

<!--<style>
.ex-list-sec {
  font-family: "Source Sans Pro", sans-serif;
}

.ex-list-sec .ex-list-title h2 {
  color: #c09a5d;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 30px;
  font-family: "Source Sans Pro", sans-serif;
  text-transform: uppercase;
}

.ex-list-sec .ex-list-title {
  width: 100%;
}

.ex-list-sec .ex-list-title p {
  color: #6d6f71;
  font-size: 17px;
  font-family: "Source Sans Pro", sans-serif;
}

.ex-list-sec .ex-list-title p a {
  color: #2a3986;
  text-decoration: none;
}

.ex-list-sec .ex-list-search h3 {
  width: 100%;
  background-color: #c09a5d;
  color: White;
  padding-left: 3px;
  line-height: 24px;
  min-height: 55px;
  padding: 0 10px;
  text-transform: uppercase;
  font-size: 22px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.ex-list-sec .ex-list-form {
  max-width: 60%;
  margin-top: 30px;
  width: 60%;
}

.ex-list-sec .ex-list-search {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.ex-list-sec .ex-list-form .form-control {
  border: 1px solid #c09a5d;
  padding: 5px;
  height: 38px;
  border-radius: 0;
  box-shadow: none;
  width: 265px;
  font-size: 15px;
  outline: none;
  box-sizing: border-box;
}

.ex-list-sec .ex-list-form label {
  color: #a3a4b8;
  font-size: 17px;
  line-height: 27.2px;
  font-weight: 700;
  padding-right: 15px;
  width: 30%;
  text-transform: uppercase;
}

.ex-list-sec .ex-list-form .ex-btn-wrap {
  max-width: 100%;
  margin: 0 15px 15px;
}

.ex-list-sec .ex-list-form .ex-btn-wrap .ex-btn-blue {
  background: #c09a5d;
  padding: 11px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  color: #ffffff;
  margin-right: 10px;
  border: none;
  cursor: pointer;
  border-radius: 0;
  font-size: 17px;
  text-transform: uppercase;
  margin-bottom: 10px;
  min-width: 110px;
}

.ex-list-sec .ex-list-form .ex-btn-wrap .ex-btn-blue:hover {
  background: #000000;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
  color: #ffffff;
}

.ex-list-sec .ex-list-form .form-group {
  width: 100%;
  margin: 0 15px 15px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.ex-list-sec .ex-list-form {
  margin-right: -15px;
  margin-left: -15px;
}

.ex-list-sec .alphabet-wrap {
  text-align: center;
  margin-top: 30px;
}

.ex-list-sec .alphabet-wrap a {
  background: #c09a5d;
  padding: 5px 10px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  color: #ffffff;
  margin-right: 3px;
  margin-bottom: 5px;
  display: inline-block;
  text-transform: uppercase;
  font-size: 17px;
}
.ex-list-sec .alphabet-wrap a:last-child {
  padding: 8px;
  margin-left: 10px;
  background: #8a8a8a;
}
.ex-list-sec .alphabet-wrap a:hover {
  background: #000000;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
  color: #ffffff;
  cursor: pointer;
}

.ex-list-sec .filter-wrap-table {
  margin-top: 30px;
}

.ex-list-sec .filter-wrap-table table img {
  width: 21px;
  height: 21px;
}

.ex-list-sec .filter-wrap-table .list-table th {
  color: #ffffff;
  background: #8a8a8a;
  font-weight: bold;
  font-size: 14px;
  padding: 8px;
}

.ex-list-sec .filter-wrap-table .list-table td {
  color: rgb(109, 111, 113);
  font-size: 14px;
  padding: 8px;
}

.ex-list-sec .filter-wrap-table .list-table td a {
  color: rgb(109, 111, 113);
  font-size: 14px;
  text-decoration: none;
}

@media (max-width: 1024px) {
  .ex-list-sec .ex-list-form label {
    width: 100%;
  }

  .ex-list-sec .ex-list-form .ex-btn-wrap {
    max-width: 100%;
  }
}

@media (max-width: 767px) {
  .ex-list-sec .ex-list-form .form-group {
    width: calc(100% / 2 - 32px);
  }
}

@media (max-width: 576px) {
  .ex-list-sec .ex-list-form .form-control {
    width: 100%;
  }

  .ex-list-sec .ex-list-form .form-group {
    display: block;
  }

  .ex-list-sec .ex-list-form .form-group {
    width: calc(100% / 1 - 32px);
  }
}

span.noDataClass {
  display: block;
  width: 100%;
  text-align: center;
  padding: 100px 0px;
  font-size: 30px;
  color: #484748;
}

.pagination_Exhibitor {
  display: inline-block;
  margin-left: -20px;
  padding: 15px 25px;
}
.pagination_Exhibitor a {
  color: black;
  float: left;
  padding: 11px 20px;
  text-decoration: none;
  border-radius: 50%;
}

.pagination_Exhibitor a:hover {
  background-color: #e6e6e6;
}

.pagination_Exhibitor a.active {
  background-color: #224693 !important;
  color: white;
  border-radius: 50%;
}
.cover-wrapper .exhibitor-head h4 {
  font-size: 28px;
  font-weight: 700;
  color: #c09a5d;
  text-transform: uppercase;
}

.cover-wrapper a.bck-btn {
  background: #000000;
  padding: 12px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  color: #ffffff;
  margin-bottom: 10px;
  border: none;
  cursor: pointer;
  float: right;
  display: block;
  text-transform: uppercase;
  text-decoration: none;
}

.cover-wrapper a.bck-btn:hover {
  text-decoration: none;
  background: #000000;
}

.cover-wrapper .back-button {
  display: block;
}

.cover-wrapper .back-button:after {
  content: "";
  display: table;
  clear: both;
}

.cover-wrapper .header-content {
  font-weight: bold;
  background: #c09a5d;
  padding: 7px 15px;
  color: #fff;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
}
.cover-wrapper .header-content .left-text{
      flex: 8;
}
.cover-wrapper .header-content .right-text{
      flex: 2;
      text-align:right;
}
@media (max-width: 500px) {
  .cover-wrapper .header-content {
    display: block;
    text-align: center;
  }
  .cover-wrapper .header-content .right-text,.cover-wrapper .header-content .left-text{
      flex: none;
      text-align:center;
 }
}

.cover-wrapper .header-content .left-text h5 {
  font-weight: 700;
  font-size: 25px;
  margin: 10px 0;
  text-transform: uppercase;
  color: #fff;
}

.cover-wrapper .header-content .right-text h5 {
  font-weight: 700;
  font-size: 25px;
  margin: 10px 0;
  color: #fff;
}
@media screen and (max-width:767px){
  .cover-wrapper .header-content .right-text h5,.cover-wrapper .header-content .left-text h5{
    font-size: 20px;
  }
}
nav li {
  display: block;
  padding: 10px 26px;
  color: #ffffff;
}
.cover-wrapper .nav-tabs {
  padding-left: 0;
  margin: 0;
  list-style: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 1px;
}
.cover-wrapper .nav-tabs li {
  color: #fff;
  margin-right: 2px;
  padding: 0px 0 0 0;
  cursor: pointer;
  list-style-type: none;
}
@media (max-width: 500px) {
  .cover-wrapper .nav-tabs li {
    width: 100%;
    margin: 4px 0px !important;
    text-align: center;
  }
}

.cover-wrapper .nav-tabs > li > a {
  margin-right: 0px;
}

.cover-wrapper .nav-tabs > li.active > a,
.nav-tabs > li.active > a:focus,
.nav-tabs > li.active > a:hover {
  color: #fff;
  background-color: #000000 !important;
}

.cover-wrapper .nav-tabs > li.active > a {
  background-color: #000000 !important;
}

.cover-wrapper .nav > li > a:focus,
.nav > li > a:hover {
  text-decoration: none;
  background-color: #000000 !important;
  color: #fff;
}

.cover-wrapper .nav > li > a {
  position: relative;
  display: block;
  padding: 10px 14px;
  background-color: #c09a5d;
  color: #fff;
  border-radius: 0px;
}
.cover-wrapper .tabs .tab-content {
  clear: both;
}
.cover-wrapper .tabs .tab-content .tabcontent h3 {
  font-size: 22px;
  margin: 10px 0;
  color: #fff;
}
.cover-wrapper .tabs .tab-content .tabcontent ul li {
  padding-bottom: 5px;
  font-size: 17px;
}
.cover-wrapper .company-des h3 {
  font-size: 28px;
  color: #c09a5d;
  font-weight: 600;
  margin-bottom: 10px;
  text-transform: uppercase;
  margin-top: 30px;
}

.cover-wrapper .company-des p {
  font-size: 17px;
  line-height: 1.3;
}

.ex-details h4 {
  color: #1a1c21;
  font-weight: 700;
  font-size: 25px;
  text-transform: uppercase;
  margin-bottom: 12px;
}

.ex-details .ex-details-list li {
  list-style-type: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 10px;
}

.ex-details .ex-details-list {
  padding: 0;
}

.ex-details .ex-details-list li img {
  width: 21px;
  height: 21px;
  margin-right: 15px;
}

.ex-details .ex-details-list li span {
  font-size: 17px;
  font-weight: 300;
  color: #6d6f71;
}
.simple-pagination {
  margin: 25px 0 0 !important;
}

.ex-list-sec .ex-details {
  max-width: 40%;
  width: 40%;
  margin-top: 30px;
}

.loading-wrap {
  display: none;
}
.loading-wrap {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.66);
  z-index: 9999;
  height: 100%;
  width: 100%;
}
.loader {
  width: 3em;
  height: 3em;
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  overflow: hidden;
}
.loader img {
  animation: spin 1s infinite linear;
  height: 3em;
  width: 3em;
  display: inline-block;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.companylogo {
  display: flex;
  align-items: center;
  padding-bottom: 15px;
}

.address {
  padding-left: 30px;
}

.companylogo .address {
  max-width: 350px;
}
.companylogo .address p{
  font-size: 18px;
}
.companylogo .address pre {
  font-size: 17px;
  color: #6d6f71;
  overflow: initial;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.companylogo .address b {
  color: #6d6f71;
  font-size: 18px;
}
.companylogo .address p a {
  color: #c09a5d;
  text-decoration: none;
}
.companylogo .address p a:hover {
  text-decoration: underline;
}
.tabcontent {
  background-color: #949494;
  color: #ffffff;
  padding: 15px;
}

.tabcontent a {
  color: #ffffff;
  text-decoration: none;
}
.ex-profile-sec {
  margin-top: 50px;
}
.productgallery_wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-line-pack: center;
  align-content: center;
}
.productgallery_wrap img {
  max-width: 250px;
}
.productgallery_wrap .productgallery_details {
  padding: 0 25px;
  width: calc(100% - 315px);
}
.productgallery_wrap .productgallery_details p b {
  color: #6d6f71;
  font-size: 18px;
  text-transform: uppercase;
}
@media (max-width: 670px) {
  .productgallery_wrap .productgallery_details {
    width: 100%;
  }
}

.image-wrap {
  width: 250px;
  height: 250px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background: #e4e4e46b;
}

.image-wrap img {
  margin: auto;
}
@media (max-width: 670px) {
  .productgallery_wrap .productgallery_details {
    padding-left: 0;
    padding-top: 15px;
  }
}
.productgallery_wrap img {
  max-height: 250px;
}
.cover-wrapper hr {
  border: 0.5px solid #c09a5d;
}
.pagination > .active > a,
.pagination > .active > span,
.pagination > .active > a:hover,
.pagination > .active > span:hover,
.pagination > .active > a:focus,
.pagination > .active > span:focus {
  color: #fff !important;
}
.exhibitor-head-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.cover-wrapper .exhibitor-head {
  width: 50%;
}
.cover-wrapper .back-button {
  width: 50%;
}
.productgallery_details pre {
   font-size: 15px;
   color: #6d6f71;
   line-height: 1.3;
   overflow: initial;
   white-space: pre-wrap;
   word-wrap: break-word;
   text-align: justify;
}
/*Responsive*/
@media screen and (max-width: 767px) {
  .ex-list-sec {
    margin: 0 15px !important;
  }
  .ex-list-sec .ex-list-form,
  .ex-list-sec .ex-details {
    width: 100%;
    max-width: 100%;
  }
  .ex-list-sec .ex-list-search h3 {
    font-size: 17px;
  }
  .cover-wrapper .exhibitor-head h4 {
    font-size: 22px;
  }
  .cover-wrapper {
    margin: 0;
  }
  .productgallery_wrap {
    display: block;
    width: 100%;
    text-align: center;
  }
  .productgallery_wrap .productgallery_details {
    width: 100%;
    padding: 0;
    margin-top: 20px;
  }
  .cover-wrapper .company-des h3 {
    text-align: center;
    font-size: 25px;
    margin-bottom: 20px;
  }
  .companylogo {
    display: block;
    text-align: center;
    width: 100%;
  }
  .companylogo .address {
    max-width: 100%;
    padding: 0;
  }
}
@media screen and (max-width: 575px) {
  .exhibitor-head-wrapper {
    display: block;
    text-align: center;
  }
  .cover-wrapper .exhibitor-head,
  .cover-wrapper .back-button {
    width: 100%;
  }
  .cover-wrapper a.bck-btn {
    float: none;
  }
}
@media screen and (max-width: 500px) {
  .cover-wrapper .exhibitor-head h4 {
    text-align: center;
    margin: 17px 0;
  }
  .tabcontent ul {
    padding-left: 20px;
  }
  .container-fluid {
    padding: 0;
  }
}
</style>-->
